import { app } from '../../bootstrap/core';
import {
  LoginService,
  AdminService,
  RequestFieldsService,
  OutgoingRequestFieldsService,
  CreditorsService,
  TicketsService,
  TicketsProvider,
  ReportService,
  SepaCountries,
  PADContactService,
} from './dataSource';

app.service('loginService', LoginService);
app.service('adminService', AdminService);
// TODO for the sake of consistency rename these service to lowerCase
app.service('RequestFields', RequestFieldsService);
app.service('OutgoingRequestFields', OutgoingRequestFieldsService);
app.service('creditorsService', CreditorsService);
app.service('ticketsDataService', TicketsService);
app.provider('Tickets', TicketsProvider);
app.factory('SepaCountries', SepaCountries);
app.service('reportService', ReportService);
app.service('padContactService', PADContactService);
